import React from 'react'
import {Header} from 'semantic-ui-react'
import {AuthenticationOverview} from './authentication-overview'
import {CreateAccount} from './create-account'
import {Login} from './login'
import {Logout} from './logout'
import {ResetPassword} from './reset-password'
import {Router} from '@reach/router'
import {SectionMenu} from '../../section-menu'

const AuthenticationSection = ({navigate, location}) => {
  const menuItems = [
    'Overview',
    'Create Account',
    'Log In',
    'Log Out',
    'Reset Password'
  ]
  return (
    <>
      <Header as='h2'>Authentication</Header>
      <SectionMenu isLeftNav={false} navigate={navigate} location={location} menuItems={menuItems}/>
      <Router>
        <AuthenticationOverview default/>
        <CreateAccount path='create-account'/>
        <Login path='log-in'/>
        <Logout path='log-out'/>
        <ResetPassword path='reset-password'/>
      </Router>
    </>
  )
}

export {AuthenticationSection}

export default AuthenticationSection